import React from "react";
import { bool, shape, number, string, func } from "prop-types";
import classNames from "classnames";

import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import Hint from "pages/_components/hints/Hint";

import * as i18n from "util/i18n";
import * as config from "util/config";
import getRescueDeadlineLabel from "util/fundcorp";
import FundSuscriptionCard from "./FundSuscriptionCard";

function SelectedFundInfo({ isDesktop, selectedFundFeature, deselectFundFeature }) {
    const orderFuncionality = config.getBoolean("backend.show.managementFunds.functionalities", false);

    const { nombre, monedaDescripcion, rescatePlazo, regionDescripcion: nivelRiesgo, title } = selectedFundFeature;

    return orderFuncionality ? (
        <div className="px-3">
            <div className="fundcorp__suscribe-hint">
                <Hint
                    defaultValue={title}
                    classNameGroup="d-flex align-items-center w-100 mb-2"
                    classNameHintP="m-0 ml-2"
                    alwaysShowMessage
                />
            </div>
            <FundSuscriptionCard isDesktop={isDesktop} {...selectedFundFeature} />
        </div>
    ) : (
        <div
            className={classNames(" d-flex space-between w-100 px-0", {
                "px-3": !isDesktop,
                "pt-4": isDesktop,
            })}>
            <div className={classNames("w-100 px-md-3", { container: isDesktop })}>
                <div className={classNames("d-flex")}>
                    <I18n
                        id="fund.info.label.fund"
                        component="p"
                        componentProps={{ className: "f-size-55 text-uppercase pr-1 mb-0" }}
                    />
                    <p className="f-size-55 font-light text-uppercase pr-1 mb-0">{nombre}</p>
                </div>
                <div className={classNames("d-flex")}>
                    <I18n
                        id="fund.info.label.description"
                        component="p"
                        componentProps={{ className: "f-size-55 text-uppercase pr-1 mb-0" }}
                    />
                    <p className="f-size-55 font-light text-uppercase pr-1 mb-0">
                        {i18n.get("fund.info.label.rentaFija")} {monedaDescripcion}
                    </p>
                </div>
                <div className={classNames("d-flex")}>
                    <I18n
                        id="fund.info.label.rescueTerm"
                        component="p"
                        componentProps={{ className: "f-size-55 text-uppercase pr-1 mb-0" }}
                    />
                    <p className="f-size-55 font-light text-uppercase pr-1 mb-0">
                        {getRescueDeadlineLabel(rescatePlazo)}
                    </p>
                </div>
                <div className={classNames("d-flex")}>
                    <I18n
                        id="fund.info.label.risk"
                        component="p"
                        componentProps={{ className: "f-size-55 text-uppercase pr-1 mb-0" }}
                    />
                    <p className="f-size-55 font-light text-uppercase pr-1 mb-0">{nivelRiesgo}</p>
                </div>
            </div>
            <div className="align-items-start">
                <button className="btn-link pt-2" type="button" onClick={deselectFundFeature}>
                    <Image src="images/cross-mobile-blue.svg" styles={{ width: "25px", height: "25px" }} />
                </button>
            </div>
        </div>
    );
}

SelectedFundInfo.propTypes = {
    isDesktop: bool.isRequired,
    selectedFundFeature: shape({
        numero: number,
        rescatePlazo: number,
        suscripcionPlazo: number,
        nombre: string,
        estaAnulado: bool,
        horizonteInversionDescripcion: string,
        moneda: string,
        monedaDescripcion: string,
        regionDescripcion: string,
        title: string,
        importeMin: string,
        horaDesde: string,
        horaHasta: string,
    }).isRequired,
    deselectFundFeature: func.isRequired,
};

export default SelectedFundInfo;
